import React from 'react'
import { generalStrings } from 'src/common/generalStrings'
import { Button } from 'src/components/Button'
import { PaginatedTable } from 'src/components/PaginatedTable'
import { useDrawer } from 'src/hooks/useDrawer'
import { areFiltersOn } from 'src/pages/Learn/types'
import { useMeQuery } from 'src/store/APIs/misc'
import { useLazyGetNavigatorsQuery } from 'src/store/APIs/navigators'
import { UserType } from 'src/store/APIs/types'

import styles from '../webPortalUsers.module.scss'
import { useNavigatorsColumns } from './columns'
import { NavigatorsDrawer } from './NavigatorsDrawer'
import { strings } from './strings'

interface NavigatorsProps {}

export const Navigators: React.FC<NavigatorsProps> = () => {
  const { open, onCloseDrawer, selectedId, openView, showDrawer } = useDrawer()
  const { resetFilters, ...columnsAndFilters } = useNavigatorsColumns(openView)
  const { data } = useMeQuery()

  const filtersOn = areFiltersOn(columnsAndFilters.filteredInfo.filters)

  return (
    <div className={styles.container}>
      <div className={styles.buttonContainer}>
        <Button
          className={styles.buttonStyle}
          onClick={resetFilters}
          disabled={!filtersOn}>
          {generalStrings.clearFiltersButtonLabel}
        </Button>
        {data?.user.user_type === UserType.admin && (
          <Button
            type="primary"
            className={styles.buttonStyle}
            onClick={showDrawer}>
            {strings.addNavigatorButtonLabel}
          </Button>
        )}
      </div>
      <NavigatorsDrawer
        onCloseDrawer={onCloseDrawer}
        open={open}
        selectedId={selectedId}
      />
      <PaginatedTable
        className={styles.table}
        useLazyQuery={useLazyGetNavigatorsQuery}
        {...columnsAndFilters}
      />
    </div>
  )
}
